import { useSelector, useDispatch } from "react-redux";
import * as appActions from "../../../../store/actions/app";
import styles from "./Header.module.css";

function Header({ title }) {
  const dispatch = useDispatch();
  let origin = useSelector((state) => state.app.origin);

  const onReturn = () => {
    dispatch(appActions.setLoading(true));
    sessionStorage.removeItem("appState");
    window.location.href = origin.url;
  };
  let buttonMessage;
  if (origin.type === "ays") {
    buttonMessage = "Back to @yourservice";
  } else if (origin.type === "cc") {
    buttonMessage = "Back to Customer Care";
  } else {
    buttonMessage = "Back to Login";
  }

  return (
    <header className={styles.container}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <div className={styles.headerContainer}>
        <button className={styles.backButton} onClick={() => onReturn()}>
          {buttonMessage}
        </button>
      </div>
    </header>
  );
}

export default Header;

/*
function Header() {
    const dispatch = useDispatch();
    let origin = useSelector(state => state.app.origin);

    const onReturn = () => {
        dispatch(appActions.setLoading(true));
        sessionStorage.setItem("appState", "");
        origin.type === 'ays' ? window.location.href = origin.url : window.location.href = origin.url + `?token=${JSON.parse(sessionStorage.getItem("ud")).rt}`;
    }

    return (
        <div className={styles.container}>
        {title && <div className={styles.title}>{title}</div>}
            <div className={styles.headerContainer}>
            <button className={styles.backButton} onClick={() => onReturn()}>{origin.type === 'ays' ? "Back to @yourservice" : "Back to Customer Care"}</button>
            </div>
        </div>
    )
}
*/
